import { OpenAPIClientAxios } from 'openapi-client-axios';

import store from '@/store'
import router from '@/router'

import { requestIntercepter } from './common'
import definition from './openapi.json';


const _subAccountSessionRequestIntercepter = (config) => {
  // load subAccountRelationId from store if subAccount session is active
  const subAccountRelationId = store.state?.selectedSubAccountRelation?.id;

  if (subAccountRelationId) {
      // include subAccountRelationId in the request as a query parameter
      config.params = { ...config.params, subAccountRelationId };
  }

  return config;
};

const _tokenAuthRequestIntercepter = (config) => {
  // load token from store if available
  const token = store.getters.getToken;

  if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
};


let _mainAPIClientPromise = null;
let _defaultAPIClientPromise = null;


const createAPI = () => {
  const api = new OpenAPIClientAxios({
    definition: definition,
    axiosConfigDefaults: {
        baseURL: OPENAPI_BASE_URL,
    }
  });
  api.init();

  return api;
};

const mainAPI = createAPI();
const defaultAPI = createAPI();


export function getMainAPIClient() {
    if (!_mainAPIClientPromise) {
      _mainAPIClientPromise = mainAPI.getClient().then((client) => {
        client.interceptors.request.use(_tokenAuthRequestIntercepter);
        client.interceptors.request.use(_subAccountSessionRequestIntercepter);
        client.interceptors.request.use(requestIntercepter);
        client.interceptors.response.use(
          (response) => {
            if (response && response.data && response.data.action === "PLAN_REQUIRED") {
              store.commit("showPlanRequiredModal", { reason: response.data.msg || "api" });
            }
            return response;
          },
          (error) => {
            if (error.response?.status === 401) {
              console.log("error in http response ", error.response);
              store.commit("clearStore");
              if (error.response.data.message) {
                store.commit("setGlobalErrorMsg", {
                  msg: error.response.data.message,
                });
              }
              // We don't want to navigate to /login if we are already there
              if (router.currentRoute.path !== "/login") {
                router.push("/login");
              }
            }
            return Promise.reject(error);
          },
        );
        return client;
      });
    }

    return _mainAPIClientPromise;
}

export function getDefaultAPIClient() {
    if (!_defaultAPIClientPromise) {
      _defaultAPIClientPromise = defaultAPI.getClient().then((client) => {
        client.interceptors.request.use(_tokenAuthRequestIntercepter);
        client.interceptors.request.use(_subAccountSessionRequestIntercepter);
        client.interceptors.request.use(requestIntercepter);
        client.interceptors.response.use(
          (response) => {
            if (response && response.data && response.data.action === "PLAN_REQUIRED") {
              store.commit("showPlanRequiredModal", { reason: response.data.msg || "api" });
            }
            return response;
          },
          (error) => {
            if (error.response?.status === 401) {
              console.log("error in http response ", error.response);
              store.commit("clearStore");
              if (error.response.data.message) {
                store.commit("setGlobalErrorMsg", {
                  msg: error.response.data.message,
                });
              }
            }
            return Promise.reject(error);
          },
        );
        return client;
      });
    }

    return _defaultAPIClientPromise;
}
